import React, { createContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import request from '../../../Helpers/API';
import PlantillaScreen from '../../helpers/PlantillaScreen';
import { Button } from '@mui/material';
import ModalTasasValoresScree from './ModalTasasValoresScree';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LoaderScreen } from '../../components/LoaderScreen';

export const Context = createContext();

const ListadoTasasValoresScreen = () => {
    const history = useHistory();
    const location = useLocation();
    const idtipo_tasa = location.state && location.state.idtipo_tasa;
    const descripcion = location.state && location.state.descripcion;

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [modalAbierto, setModalAbierto] = useState(false); // Estado para controlar el modal abierto

    const [informacion, setInformacion] = useState({
        open: false,
        item: -999,
        data: [],
    });

    const contextValue = useMemo(
        () => ({
            state: informacion,
            setState: setInformacion,
        }),
        [informacion, setInformacion]
    );

    const openModal = (item) => {
        setInformacion({
            ...informacion,
            open: true,
            item: item,
        });
        setModalAbierto(true); // Cambia el estado del modal a abierto cuando se abre
    };

    useEffect(() => {
        actualizarListado();
    }, [modalAbierto]);

    const actualizarListado = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`FTasaInteresValores/Listado?idtipo_tasa=${idtipo_tasa}`)
            .then((result) => {
                setInformacion({
                    ...informacion,
                    data: result,
                });
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("INTERESES", JSON.stringify(error), "error");
            });
    };



    return (
        <PlantillaScreen
            titulo={`TASAS ${descripcion.toUpperCase()}`}
            className={"listado-tasa-intereses-main-screen"}
            className_main={1}
        >
            <Context.Provider value={contextValue}>
                <LoaderScreen loader={loader} />
                <div>
                    <div className="tasa-intereses-valores-boton-agregar">
                        <Button
                            onClick={() => openModal()}
                            variant="contained"
                            sx={{ height: 30 }}
                        >
                            Agregar
                        </Button>
                    </div>
                    <ModalTasasValoresScree
                        idtasa_valor={informacion.item}
                        idtasa={idtipo_tasa}
                        updatedata={actualizarListado}
                        descripcion={descripcion}
                        onClose={() => setModalAbierto(false)} // Cambia el estado del modal a cerrado cuando se cierra
                    />
                    <div className="tabla-tasa-intereses-valores scroll-4">
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>
                                        PLAZO
                                    </th>
                                    <th>
                                        <div>PORCENTAJE</div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {informacion.data.map((item) => (
                                    <tr>
                                        <td className='ta-right'>{item.plazo}</td>
                                        <td className='ta-right'>{item.porcentaje}</td>
                                        <td className='ta-center'>
                                            <div className="boton-editar-tasa-interes-valores" onClick={() => openModal(item.idtipo_tasa_valor)}>
                                                Editar
                                            </div>
                                            {/* <EditIcon /> */}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="tasa-intereses-valores-container-footer">
                        <div
                            className="Tasa-intereses-valores-container-footer-boton-regresar"
                            onClick={() =>
                                history.push(
                                    "/Credito/Intereses2"
                                )
                            }
                        >
                            <ArrowBackIcon /> REGRESAR
                        </div>
                    </div>
                </div>
            </Context.Provider>
        </PlantillaScreen>
    )
}

export default ListadoTasasValoresScreen
